import React from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { EmptyStateAddButton } from './EmptyStateAddButton';

interface PanelEmptyStateProps {
  illustration: React.ReactNode;
  title: string;
  description: string;
  actions?: React.ReactNode;
  footer?: React.ReactNode;
}

export const PanelEmptyState: React.FC<PanelEmptyStateProps> = ({
  illustration,
  title,
  description,
  actions,
  footer,
}) => {
  return (
    <div className="flex w-full flex-1 flex-col items-center justify-center px-6 py-12 text-center">
      {illustration}
      <h3 className="max-w-sm text-base font-semibold text-foreground">{title}</h3>
      <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">{description}</p>
      {actions ? (
        <div className="mt-5 flex flex-wrap items-center justify-center gap-2">{actions}</div>
      ) : null}
      {footer}
    </div>
  );
};

interface AddablePanelEmptyStateProps {
  illustration: React.ReactNode;
  titleKey: string;
  descriptionKey: string;
  addLabelKey: string;
  canEdit: boolean;
  onAdd: () => void;
  footer?: React.ReactNode;
}

export const AddablePanelEmptyState: React.FC<AddablePanelEmptyStateProps> = ({
  illustration,
  titleKey,
  descriptionKey,
  addLabelKey,
  canEdit,
  onAdd,
  footer,
}) => {
  const { t } = useLocale();

  return (
    <PanelEmptyState
      illustration={illustration}
      title={t(titleKey)}
      description={t(descriptionKey)}
      actions={canEdit ? <EmptyStateAddButton onClick={onAdd}>{t(addLabelKey)}</EmptyStateAddButton> : undefined}
      footer={footer}
    />
  );
};
